const GridTotalsComponent = {
    templateUrl: '/content/gridTotals/gridTotals.tpl.html',
    controller: 'gridTotalsController',
    bindings: {
        totalData: '<',
        colViewModel: '<'
    }
};

angular.module('gw-um-submission')
    .component('gridTotals', GridTotalsComponent);
